import { isInSilentLoginIframe } from '../init/initUtils'
import silent from './silent'
import type { SparkySettings } from '../framework/microAppTypes'

const render = async (settings: SparkySettings) => {
  if (isInSilentLoginIframe) {
    silent(settings)
  }
  else {
    const { default: render } = await import(/* webpackPreload: true */ './app')
    render(settings)
  }
}

export default render
